module.exports = __webpack_public_path__ + "img/chair.3285ddcf.png";